module.exports = __webpack_public_path__ + "img/decor.62a28586.svg";